import { makeStyles } from "@material-ui/core";
import styled from "styled-components";
import { theme as themeConfig } from "@themes";

export const CardsWrapperUsers = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 10px;
  user-select: none;
  .MuiPaper-elevation2 {
    box-shadow: none;
  }
  .cards-wrapper {
    display: flex;
    flex-wrap: wrap;
  }
  .right-section {
    display: flex;
  }
`;
export const ContentTable = styled.div`
  grid-column: 1/4;
  padding: ${({ isUserHistoryTable }) => (isUserHistoryTable ? "10px" : "0px")};
  .MuiPaper-root {
    background-color: ${({ theme }) => theme.background.light};
    box-shadow: none;
  }
  .MuiTableCell-alignLeft {
    text-align: center;
  }
  .MuiTableCell-root{
    padding: ${({ isUserHistoryTable }) => (isUserHistoryTable ? "12px" : "16px")};
  }
  th {
    background-color: ${({ theme }) => theme.neutral.gray[800]} !important;
    z-index: 1 !important;
  }
  tr:nth-child(even) {
    background-color: ${({ theme }) => theme.neutral.gray[200]};
  }
  .MuiPaper-root > .MuiToolbar-root {
    display: none;
  }
`;
export const LobContent = styled.div`
  &:hover > .infoLobs {
    display: block;
  }

  .infoLobs {
    background: #00000099;
    width: auto;
    padding: 1em;
    /* list-style-type: none; */
    z-index: 1;
    overflow-wrap: normal;
    display: none;
  }
`;

export const Convention = styled.div`
  display: flex;
  width: 22em;
  height: auto;
  padding-top: 1em;
  align-items: center;
  justify-content: flex-start;
  margin-left: 10px;
  p {
    margin: 0 1em 0 0.4em;
  }
`;
export const ActionDownLoadBulkError = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: center;
  img {
    width: 13px;
    height: 16px;
    margin-right: 7px;
  }
  p {
    color: #c30091;
    margin: 0;
  }
`;
export const ContentLoaderBulk = styled.div`
  grid-column: 1/4;
  display: flex;
  text-align: center;
  height: 69vh;
  align-items: center;
`;
export const LoadingFile = styled.div`
  display: inline-flex;
  span {
    margin-left: 7px;
    color: #3950d0;
  }
`;

export const CardsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  user-select: none;
`;

export const ContentDownloadFile = styled.div`
  display: flex;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
`;

export const TextDownloadFile = styled.span`
  text-decoration: none;
  color: ${({ theme }) => theme.neutral.black};
  &:hover {
    text-decoration: underline;
  }
`;

export const LobContentName = styled.div`
  background: rgb(240, 240, 240);
  padding: 5px;
  width: fit-content;
  margin-top: 10px;
  height: 29px;
  border-radius: 7px;
  div:nth-child(1) {
    background: ${({ theme }) => theme.primary.purple};
    color: white;
    border-radius: 13px;
    width: 19px;
    text-align: center;
    font-size: 11px;
    position: relative;
    top: -30px;
    left: 27px;
  }
`;
export const useStyles = makeStyles(() => ({
  active: {
    "& svg": {
      color: themeConfig.button.primary,
    },
    "&:disabled svg": {
      color: themeConfig.neutral.gray[1200],
    },
  },
  delete: {
    color: themeConfig.button.primary,
  },
  tabs: {
    backgroundColor: themeConfig.background.secondary,
  },
}));
